import { useFormikContext } from "formik";
import { FC, useEffect, useMemo } from "react";

import { usePopupImportFunnelOptions } from "../PopupImportFunnelOptionsContext";
import { usePopupImportResolution } from "../PopupImportResolutionContext";
import { applyPopupImportVerificationResolution } from "../popupImportVerificationResolution";
import type { PopupImportFormValues } from "../validationSchema";

const ERR_FUNNEL = "該当するファネルが見つかりません";
const ERR_PAGE = "該当するページが見つかりません";

/** When funnel list loads or verification fields change, validate and canonicalize IDs/URLs. */
export const PopupImportVerificationSync: FC = () => {
  const { funnelOptions } = usePopupImportFunnelOptions();
  const { values, setValues } = useFormikContext<PopupImportFormValues>();
  const { setMessage, clearMessage } = usePopupImportResolution();

  const verificationKey = useMemo(
    () =>
      values.popups
        .map(
          (r) =>
            `${r.verificationFunnelId}\t${r.verificationPageId}\t${r.verificationPageUrl}`
        )
        .join("|"),
    [values.popups]
  );

  useEffect(
    () => {
      const { next, changed } = applyPopupImportVerificationResolution(
        values.popups,
        funnelOptions,
        {
          onInvalidFunnel: (i) => {
            setMessage(i, "funnel", ERR_FUNNEL);
            clearMessage(i, "page");
          },
          onClearFunnelMessage: (i) => clearMessage(i, "funnel"),
          onClearPageWhenNoFunnel: (i) => clearMessage(i, "page"),
          onResolvedPage: (i) => clearMessage(i, "page"),
          onInvalidPage: (i) => setMessage(i, "page", ERR_PAGE),
          onClearPageOnly: (i) => clearMessage(i, "page"),
        }
      );
      if (changed) {
        void setValues({ popups: next });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- values.popups covered by verificationKey; listing it would re-run on every cell edit
    [funnelOptions, verificationKey, setMessage, clearMessage, setValues]
  );

  return null;
};
